<template>
  <div id="personalDetails">
    <Summary v-if="anyProduct" defaultScreen="product" :disableDataPanel="true"/>
    <ValidationObserver ref="observer" @submit.prevent="next()" slim>
      <div class="form" :class="[$mq, {TA:isTestAchat}]">
        <h1>{{ $t("Situation.PersonalDetails.title") }}</h1>
        <BecomeField
          v-if="!fromCustomer && !agentCustomId"
          name="isCustomer"
          type="checkbox"
          :checkLabel="$t('Situation.PersonalDetails.customer.isCustomer')"
          v-model="isCustomer"
        ></BecomeField>
        <div class="isCustomer" v-if="isCustomer">
          <BecomeField
            name="customerRef"
            :label="$t('Situation.PersonalDetails.customer.reference.label')"
            :help="$t('Situation.PersonalDetails.customer.reference.help')"
            v-model.trim="customerReference"
            placeholder="ME000000"
            rules="sponsor"
            type="text"
            required
          ></BecomeField>
          <BecomeField
            name="password"
            :label="$t('Situation.PersonalDetails.customer.password')"
            v-model="password"
            type="password"
          ></BecomeField>
          <button
            v-if="!isLogin"
            class="button secondary inverted connection"
            @click="loginCustomer()"
          >
            {{ $t("Situation.PersonalDetails.customer.button") }}
          </button>
          <span v-if="isLogin" class="connection"
            >{{ $t("Situation.PersonalDetails.customer.login") }}
            <SvgIcon class="loading" icon="loading"></SvgIcon
          ></span>
        </div>
        <div v-if="!isCustomer">
          <ValidationObserver v-slot="{ errors, failed }" slim>
            <div class="multi-field inline left" :class="{'error': failed}" style="display: flex">
                <BecomeField
                  name="civility"
                  type="switch"
                  required
                  v-model="civility"
                  :possibleValues="civilities"
                  silentError
                ></BecomeField>
                <BecomeField
                  name="last_name"
                  :label="$t('Situation.PersonalDetails.lastname')"
                  class="flex lastname"
                  :class="$mq"
                  type="text"
                  rules="min:2|max:64|alpha"
                  :value="lastName | capitalize"
                  @input="lastName = $event"
                  required
                  silentError
                ></BecomeField>
              <div class="error-block" v-if="Object.keys(errors).length">
                <span v-if="errors['last_name'].length">{{ errors['last_name'][0] }}</span>
                <span v-else>{{ errors['civility'][0] }}</span>
              </div>
            </div>
          </ValidationObserver>

          <BecomeField
            name="first_name"
            :label="$t('Situation.PersonalDetails.firstname')"
            :value="firstName | capitalize"
            @input="firstName = $event"
            rules="min:2|max:64|alpha"
            type="text"
            required
          ></BecomeField>
          <BecomeField
            name="birth_date"
            :label="$t('Situation.PersonalDetails.birthdate.label')"
            type="calendar"
            v-model="birthDate"
            :defaultDate="defaultDate"
            :calendarRules="birthDateRule"
            :warning='birthDateWarning'
            :required="customerType === 'resi'"
          ></BecomeField>
          <BecomeField
            name="phone"
            type="phone"
            :label="$t('Situation.PersonalDetails.phone.label')"
            :help="$t('Situation.PersonalDetails.phone.help')"
            :rules="phoneRule"
            v-model="phone"
            :placeholder="phonePlaceholder"
            required
          ></BecomeField>
          <BecomeField
            v-if="!mailRequired"
            name="noemail"
            type="checkbox"
            :checkLabel="$t('Situation.PersonalDetails.noemail')"
            :value="noemail"
            @input="changeNoEmail($event)"
          ></BecomeField>
          <BecomeField
            name="email"
            type="email"
            :label="$t('Situation.PersonalDetails.mail.label')"
            :help="$t('Situation.PersonalDetails.mail.help')"
            :rules="mailRules"
            v-model.trim="mail"
            v-if="!noemail"
            required
          ></BecomeField>
          <BecomeField
            name="locality"
            type="locality"
            :label="$t('Situation.PersonalDetails.locality')"
            v-model="locality"
            required
          ><!--rules="noSupplied"  TESTING FORFAIT PV -->
          </BecomeField>
          <span v-if="(locality && (locality.region === 'bx' && !allowBXResi))" class="error">
            {{$t('Validation.noSupplied')}}
          </span>
          <BecomeField
            name="sponsor_customer_id"
            type="text"
            :label="$t('Situation.PersonalDetails.sponsor.label')"
            :help="$t('Situation.PersonalDetails.sponsor.help')"
            rules="sponsor"
            v-if="showSponsor"
            v-model.trim="sponsor"
          ></BecomeField>
          <BecomeField
            :disabled="locality && (locality.region === 'bx' && !allowBXResi)"
            name="customerType"
            type="switch"
            :label="$t('Situation.PersonalDetails.customerType.label')"
            v-model="customerType"
            :possibleValues="customerTypes"
            required
          ></BecomeField>
          <div v-if="customerType === 'pro'">
            <BecomeField
              name="vat_number"
              type="text"
              :label="$t('Situation.PersonalDetails.vatNumber.label')"
              :help="$t('Situation.PersonalDetails.vatNumber.help')"
              :value="vatNumber"
              placeholder="BE0000000000"
              rules="vatNumber"
              @input="getEnterprise($event)"
              required
            ></BecomeField>
            <BecomeField
              name="companyName"
              type="text"
              rules="max:64"
              :label="$t('Situation.PersonalDetails.companyName')"
              v-model.trim="companyName"
              required
            ></BecomeField>
            <BecomeField
              name="legal_form"
              type="select"
              :label="$t('Situation.PersonalDetails.legalForm')"
              v-model="legalForm"
              :possibleValues="legalForms"
              required
            ></BecomeField>
          </div>
          <BecomeField
            v-if="selfService && !isTestAchat"
            name="optin"
            type="checkbox"
            :checkLabel="$t('Situation.PersonalDetails.optin')"
            v-model="optinSales"
          ></BecomeField>
        </div>
      </div>
      <div class="buttons inline right" :class="$mq" v-if="!isCustomer">
        <NextButton @click="next()" :loading="loading" />
        <!-- <button class="button main" @click="next()">
          {{ $t("next")
          }}<SvgIcon class="loading" icon="loading" v-if="loading"></SvgIcon>
        </button> -->
      </div>
    </ValidationObserver>
    <div class="help-button" :class="[$mq, {TA:isTestAchat}]">
      <div
        v-if="!showHelp"
        class="left-button-wrapper"
        @click="showHelp = true"
      >
        <div class="left-button">{{ $t('help') }}</div>
      </div>
      <Help
        v-if="showHelp"
        class="help"
        :help="$t('Situation.PersonalDetails.help')"
        @close="showHelp = false"
      ></Help>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import inscriptionService from "@/services/inscriptionService";
import customerService from "@/services/customerService";
import enterpriseService from "@/services/enterpriseService";
import leadService from "@/services/leadService";
import BecomeField from "@/components/Form/BecomeField";
import Help from "@/components/Help.vue";
import scrollToError from "@/mixins/scrollToError";
import Summary from "@/views/components/Summary.vue";
import capitalize from "@/mixins/capitalize";
import dateRules from "@/validations/dateRules";
import NextButton from "../../components/Navigation/NextButton.vue";

export default {
  mixins: [scrollToError, capitalize],
  data() {
    return {
      loading: false,
      isLogin: false,
      isCustomer: 0,
      customerRef: null,
      password: null,
      showHelp: false,
      noemail: false,
    };
  },
  computed: {
    ...mapGetters("common", ["fromLead", "fromCustomer"]),
    ...mapState("common", ["leadDataForMail"]),
    ...mapState("contract", ["id"]),
    ...mapState("subscription", ["guid", "agentCustomId", "statusScenario", "mailRequired", "showSponsor", "selfService"]),
    ...mapGetters("subscription", ["isResidential", "allowBXResi", "isTestAchat"]),
    ...mapGetters("contract", ["anyProduct"]),
    subId() {
      return this.$store.state.subscription.id;
    },
    customerReference: {
      get() {
        return this.customerRef;
      },
      set(value) {
        this.customerRef = value.toUpperCase();
      }
    },
    civility: {
      get() {
        return this.$store.state.subscription.civility;
      },
      set(value) {
        this.$store.commit("subscription/setCivility", value);
      },
    },
    civilities() {
      return [
        {
          label: this.$t("Situation.PersonalDetails.civilities.MA"),
          value: "MA",
        },
        {
          label: this.$t("Situation.PersonalDetails.civilities.MO"),
          value: "MO",
        },
      ];
    },
    lastName: {
      get() {
        return this.$store.state.subscription.lastName;
      },
      set(value) {
        this.$store.commit("subscription/setLastName", value);
        this.$store.commit("subscription/setHolderLastName", value);
      },
    },
    firstName: {
      get() {
        return this.$store.state.subscription.firstName;
      },
      set(value) {
        this.$store.commit("subscription/setFirstName", value);
        this.$store.commit("subscription/setHolderFirstName", value);
      },
    },
    birthDate: {
      get() {
        return this.$store.state.subscription.birthDate;
      },
      set(value) {
        this.$store.commit("subscription/setBirthDate", value);
      },
    },
    birthDateWarning() {
      return this.birthDate && !dateRules.birthDateWarning(this.birthDate) ? this.$t('Situation.PersonalDetails.birthdate.warning') : null;
    },
    defaultDate() {
      let date = new Date();
      date.setFullYear(date.getFullYear() - 50);

      return date;
    },
    phone: {
      get() {
        return this.$store.state.subscription.phone;
      },
      set(value) {
        this.$store.commit("subscription/setPhone", value);
      },
    },
    phonePlaceholder() {
      return this.phone.prefix === "+32" ? "498000000" : "";
    },
    phoneRule() {
      return this.phone.prefix === "+32" ? "be-phone" : "phone";
    },
    mail: {
      get() {
        return this.$store.state.subscription.mail;
      },
      set(value) {
        this.$store.commit("subscription/setMail", value);
      },
    },
    mailRules() {
      return !this.agentCustomId && !this.mailRequired ? 'max:64|email|specialchars' : 'max:64|email|noemail|specialchars'
    },
    locality: {
      get() {
        return this.$store.state.contract.address.locality
      },
      set(value) {
        if(!value) {
          return;
        }
        this.customerType = (value.region === 'bx' && !this.allowBXResi) ? 'pro' : this.customerType ;
        this.$store.commit("contract/setAddressLocality", value);
      },
    },
    sponsor: {
      get() {
        return this.$store.state.subscription.sponsorCustomerId;
      },
      set(value) {
        value = value.toUpperCase()
        this.$store.commit("subscription/setSponsorCustomerId", value);
      },
    },
    hasSponsorAlreadyBeenShown: {
      get() {
        return this.$store.state.subscription.hasSponsorAlreadyBeenShown;
      },
      set(value) {
        this.$store.commit("subscription/setHasSponsorAlreadyBeenShown", value);
      }
    },
    customerType: {
      get() {
        return this.$store.state.subscription.customerType;
      },
      set(value) {
        this.$store.commit("subscription/setCustomerType", value);
        this.$store.commit("common/setBxAllowed", value === 'pro');
      },
    },
    customerTypes() {
      return [
        {
          label: this.$t("Situation.PersonalDetails.customerType.residential"),
          value: "resi",
        },
        {
          label: this.$t("Situation.PersonalDetails.customerType.professional"),
          value: "pro",
        },
      ];
    },
    vatNumber: {
      get() {
        return this.$store.state.subscription.vatNumber;
      },
      set(value) {
        this.$store.commit("subscription/setVatNumber", value);
      },
    },
    companyName: {
      get() {
        return this.$store.state.subscription.companyName;
      },
      set(value) {
        this.$store.commit("subscription/setCompanyName", value);
      },
    },
    legalForm: {
      get() {
        return this.$store.state.subscription.legalForm;
      },
      set(value) {
        this.$store.commit("subscription/setLegalForm", value);
      },
    },
    legalForms() {
      let result = [];
      let legalForms = this.$store.state.common.legalForms;

      legalForms.forEach((legalForm) => {
        let line = {
          label: legalForm[this.$i18n.locale],
          value: legalForm.code,
        };

        result.push(line);
      });

      return result;
    },
    optinSales: {
      get() {
        return this.$store.state.subscription.optinSales;
      },
      set(value) {
        this.$store.commit("subscription/setOptinSales", value);
      },
    },
    optin: {
      get() {
        return this.$store.state.subscription.optin;
      },
      set(value) {
        this.$store.commit("subscription/setOptin", value);
      },
    },
    invoiceDeliveryMode: {
      get() {
        return this.$store.state.subscription.invoiceDeliveryMode;
      },
      set(value) {
        this.$store.commit("subscription/setInvoiceDeliveryMode", value);
      },
    },
  },
  methods: {
    changeNoEmail(value) {
      if(value === 0) this.mail = null;
      this.noemail = value;
    },
    birthDateRule(date) {
      return !dateRules.birthDate(date)
    },
    async loginCustomer() {
      this.isLogin = true;
      try {
        let login = await customerService.login(
          this.customerRef,
          this.password
        );

        if (login) {
          let subscription = await inscriptionService.getSubscriptionByCustomer(
            this.customerRef,
            login.token
          );

          await this.$store.dispatch("subscription/setSubscription", subscription);
          await this.$store.dispatch("contract/setContract", subscription.contracts[0]);

          // this.locality = Object.assign({}, this.$store.state.subscription.address.locality);
          this.$store.commit("common/setCameFrom", 'customer');
          this.isCustomer = false;
        }
      } catch (error) {
        let error = {
          customerRef: this.$t(`Validation.invalidCredential`),
          password: this.$t(`Validation.invalidCredential`),
        };
        this.$refs.observer.setErrors(error);
      }
      this.isLogin = false;
    },
    async getEnterprise(value) {
      this.vatNumber = value.trim().toUpperCase();

      if (value.match(/BE(\d{9,10})/i)) {
        try {
          let response = await enterpriseService.get(value);
          this.companyName = response.name.fr || response.name.nl;
          this.legalForm = response.legal_form;
        } catch (error) {
          if (error.response.status === 400) {
            this.$refs.observer.setErrors({
              vat_number: this.$t("Validation.vat_number"),
            });
          }
        }
      }
    },
    async createSubscription() {
      try {
        if(!this.id) {
          await this.$store.dispatch("subscription/createSubscription");
          await this.$store.dispatch("contract/createContract");
          return true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async next() {
      let valid = await this.$refs.observer.validate();
      if (valid) {
        this.loading = true;
        if(!this.subId || !this.id) {
          await this.createSubscription();
        }

        let serverValidation = await this.updateSubscription();
        this.loading = false;

        if (serverValidation === true) {
          if (this.fromLead)
          {
            if(!this.leadDataForMail.mail_date)
            {
              // create prospect if not created yet then send e-mail
              if(!this.leadDataForMail.prospect_id) {
                const prospect = {
                  uuid: this.leadDataForMail.uuid,
                  email: this.mail,
                  type: this.isResidential === 1 ? 'resi' : 'pro',
                  firstName: this.firstName,
                  lastName: this.lastName,
                  zipCode: this.locality.zipCode
                };
                await leadService.saveProspect(prospect);
              }
              else {
                const emailLeadProspect = {
                  uuid: this.leadDataForMail.uuid,
                  email: this.mail
                };
                await leadService.save(emailLeadProspect);
              }
              await leadService.getMail(this.leadDataForMail);
            }
            // this.$store.commit("common/setCameFrom", null);
            this.$router.push({ name: 'Contract' });
          }
          else
          {
            this.$store.commit("common/pushCompletedSteps", this.$route.name);
            this.$router.push({ name: 'SituationContext', params: this.$route.params });
          }
        } else {
          Object.keys(serverValidation).forEach((key) => {
            const exceptionKey = {
              mobile: 'phone',
            }
            const exceptionError = {
              email: 'noemail'
            }

            const checkValidationMessage = (key) => {
              return this.$te(`Validation.${key}`) ? this.$t(`Validation.${key}`) : this.$t(`Validation.fallback`);
            }

            let error = {};

            key = Object.keys(exceptionKey).includes(key) ? exceptionKey[key] : key;

            if (Object.keys(exceptionError).includes(key)) {
              error[key] = checkValidationMessage(exceptionError[key]);
            } else {
              error[key] = checkValidationMessage(key);
            }

            this.$refs.observer.setErrors(error);
          });
        }
      } else {
        this.scrollToError();
      }
    },
    async updateSubscription() {
      if(this.statusScenario === '1step' && this.noemail) {
        this.mail = "noemail@mega.be"
      }

      let payload = {
        language: this.$i18n.locale,
        civility: this.civility,
        is_residential: this.isResidential,
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.mail,
        birth_date: this.birthDate ? this.$moment(this.birthDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ) : null,
        post_code: this.locality.zipCode,
        city: this.locality.town,
        optin: this.optin,
        optin_sales: this.optinSales,
      };

      if(this.isTestAchat) payload.agent = this.agentCustomId;

      // let phoneNumber = this.phone.number.replace(/ +/g, "");
      payload[this.phone.type] = `${this.phone.prefix}${this.phone.number}`;

      if (this.sponsor) payload["sponsor_customer_id"] = this.sponsor;

      if (!this.isResidential) {
        payload["vat_number"] = this.vatNumber;
        payload["company_name"] = this.companyName;
        payload["legal_form"] = this.legalForm;
      }

      try {
        await inscriptionService.updateSubscription(payload);
        return true;
      } catch (error) {
        return error.response.data;
      }
    },
  },
  components: {
    BecomeField,
    Summary,
    Help,
    NextButton
},
  created() {
    this.noemail = !this.mailRequired && this.mail === 'noemail@mega.be';
    if(this.hasSponsorAlreadyBeenShown === false) this.hasSponsorAlreadyBeenShown = true;

    if(!this.legalForms.length) this.$store.dispatch("common/getLegalForms");

    dataLayer.push({
      'event' : 'pageview',
      'virtualUrl' : 'subscription-step0-completed.html'
    });
  },
};
</script>

<style lang="scss" scoped>
.help-button {
  position: fixed;
  top: 350px;
  right: 0;
}

.connection {
  font-size: 0.7rem;
  font-weight: 600;
  text-align: left;
  padding: 0;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.mobile.lastname {
  flex-basis: 100%!important;
  margin-left: 0!important;
}

.error {
  display: block;
  margin: -10px 0 15px 15px;
  font-size: 0.8rem;
  text-align: left;
  color: $red;
}

.disabled {
  opacity: 0.70;
}

</style>



// WEBPACK FOOTER //
// src/views/Situation/PersonalDetails.vue